var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-98 -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 16,
    height: 16,
    transform: "translate(98 50)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(100 51.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M18.443,19.1a1.655,1.655,0,1,0-2.962,1.016.716.716,0,0,1,.149.441v1.062a.247.247,0,0,0,.247.247h.682a.247.247,0,0,0,.247-.247v-.61a.278.278,0,0,1,.236-.274,1.655,1.655,0,0,0,1.4-1.635",
    transform: "translate(-8.448 -9.74)",
    fill: "#ff913c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M12,5.334a2.063,2.063,0,0,0-.5-1.35,1,1,0,0,1-.249-.676c0-.016,0-.032,0-.048A2.074,2.074,0,0,0,9.178,1.185h0a.327.327,0,0,1-.284-.162A2.074,2.074,0,0,0,6.053.286a.471.471,0,0,1-.481,0,2.074,2.074,0,0,0-2.9.852h0a.832.832,0,0,1-.577.522l-.087.016H2A2.074,2.074,0,0,0,.481,4.367a.413.413,0,0,1-.061.382A2.074,2.074,0,0,0,1.8,8.057a2.129,2.129,0,0,0,.337.016.886.886,0,0,1,.814.486A2.074,2.074,0,0,0,4.81,9.7l5.115-.012a2.077,2.077,0,0,0,1.807-2.476,1.871,1.871,0,0,1,.109-1.086,2.063,2.063,0,0,0,.158-.8",
    transform: "translate(0 0)",
    fill: "#ffc192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M19.437,12.247A1.887,1.887,0,0,1,19.367,11a.168.168,0,0,0-.116-.207.176.176,0,0,0-.045-.006.168.168,0,0,0-.161.121,2.215,2.215,0,0,0-.083.508,2.235,2.235,0,0,0-2.076,2.235.167.167,0,1,0,.335,0,1.9,1.9,0,0,1,1.75-1.9,2.25,2.25,0,0,0,.157.623.167.167,0,0,0,.155.1.172.172,0,0,0,.064-.012.168.168,0,0,0,.091-.219",
    transform: "translate(-9.427 -6.022)",
    fill: "#ff913c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M11.2,8.219a.167.167,0,0,0,.118-.286,1.9,1.9,0,0,1-.558-1.356.1.1,0,0,0,0-.018V6.543a1.9,1.9,0,0,1,.557-1.307A.167.167,0,0,0,11.082,5a2.234,2.234,0,0,0-.648,1.384,1.886,1.886,0,0,1-.862-.29,2.242,2.242,0,0,0,.682-1.608.168.168,0,0,0-.335,0,1.919,1.919,0,0,1-1.757,1.9,2.2,2.2,0,0,0,.017-.271,2.222,2.222,0,0,0-.227-.985.167.167,0,1,0-.3.147,1.908,1.908,0,0,1-.73,2.47,2.232,2.232,0,0,0-.383-.51.167.167,0,0,0-.237.237A1.887,1.887,0,0,1,6.848,8.6a.168.168,0,0,0,.167.148h.019a.166.166,0,0,0,.112-.062.17.17,0,0,0,.035-.124,2.268,2.268,0,0,0-.12-.5A2.243,2.243,0,0,0,8.1,6.724,2.218,2.218,0,0,0,9.3,6.316a2.215,2.215,0,0,0,1.126.4,2.23,2.23,0,0,0,.652,1.451.166.166,0,0,0,.118.049",
    transform: "translate(-3.492 -2.41)",
    fill: "#ff913c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M8.339,12.336H8.33a2.235,2.235,0,0,0-2.076,2.235.167.167,0,0,0,.335,0,1.9,1.9,0,0,1,1.75-1.9v0a.166.166,0,0,0,0-.331",
    transform: "translate(-3.492 -6.887)",
    fill: "#ff913c"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2.af721432.svg";
export { ForwardRef as ReactComponent };